<template>
  <div id="tab_member_documents" class="tab-pane fade in active" v-if="showTab">
    <div class="library__group h-center-align" v-if="loaders.vendors || pricingVendors.length > 0">
      <div class="library__group-header">Pricing</div>
      <div class="library__collection">
        <div v-if="loaders.vendors" class="loading-indicator"><MoonLoader size="75px" color="#ffffff"></MoonLoader></div>
        <PricingCard v-for="(vendor, index) in pricingVendors" :vendor="vendor" :key="`pricing-${index}`"></PricingCard>
      </div>
    </div>
    <div class="library__group h-center-align" v-if="loaders.documents || contracts.length > 0">
      <div class="library__group-header">Contracts</div>
      <div class="library__collection">
        <div v-if="loaders.documents" class="loading-indicator"><MoonLoader size="75px" color="#ffffff"></MoonLoader></div>
        <ContractCard v-for="(contract, index) in contracts" :contract="contract" :key="`contract-${index}`"></ContractCard>
        <ContractModal modal-key="contractModal"></ContractModal>
      </div>
    </div>
    <div class="library__group h-center-align" v-if="loaders.documents || edgeDocuments.length > 0">
      <div class="library__group-header">EDGE Documents</div>
      <div class="library__collection">
        <div v-if="loaders.documents" class="loading-indicator"><MoonLoader size="75px" color="#ffffff"></MoonLoader></div>
        <EdgeCard v-for="(doc, index) in edgeDocuments" :doc="doc" :key="`edge-${index}`"></EdgeCard>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { MoonLoader } from 'vue-spinner/dist/vue-spinner.min.js';
  import PricingCard from './cards/PricingCard.vue';
  import ContractCard from './cards/ContractCard.vue';
  import ContractModal from './modals/ContractModal.vue';
  import EdgeCard from './cards/EdgeCard.vue';

  export default {
    name: 'MemberDocuments',
    components: {
      MoonLoader,
      PricingCard,
      ContractCard,
      ContractModal,
      EdgeCard,
    },
    computed: {
      ...mapGetters('library', [
        'loaders',
        'pricingVendors',
        'contracts',
        'edgeDocuments',
        'activeSection',
      ]),
      showTab() {
        return this.activeSection === 'member_documents';
      },
    },
  };
</script>
